import { initI18n } from '@referee/i18n';
import en from './locales/en.json';
import de from './locales/de.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import fr from './locales/fr.json';
import pl from './locales/pl.json';
import me from './locales/me.json';
import sq from './locales/sq.json';
import consentEn from '@referee/analytics/translations/en';
import consentDe from '@referee/analytics/translations/de';
import consentEs from '@referee/analytics/translations/es';
import consentPt from '@referee/analytics/translations/pt';
import consentFr from '@referee/analytics/translations/fr';
import consentPl from '@referee/analytics/translations/pl';
import consentMe from '@referee/analytics/translations/me';
import consentSq from '@referee/analytics/translations/sq';

const i18n = initI18n({
  resources: {
    en: { translation: { ...en, ...consentEn } },
    de: { translation: { ...de, ...consentDe } },
    es: { translation: { ...es, ...consentEs } },
    pt: { translation: { ...pt, ...consentPt } },
    fr: { translation: { ...fr, ...consentFr } },
    pl: { translation: { ...pl, ...consentPl } },
    me: { translation: { ...me, ...consentMe } },
    sq: { translation: { ...sq, ...consentSq } },
  },
  supportedLngs: ['en', 'de', 'es', 'pt', 'fr', 'pl', 'me', 'sq'],
});

export default i18n;
